import { inject, Injectable, signal } from '@angular/core';
import { disabled, pattern, required, schema } from '@angular/forms/signals';
import { regexes } from '@core/utils';
import { TranslateService } from '@ngx-translate/core';
import { EcomCashoutEmailFormModel } from './form-model';

@Injectable()
export class FormSchema {
  private readonly translate = inject(TranslateService);
  readonly emailDisabled = signal(false);

  readonly schema = schema<EcomCashoutEmailFormModel>((s) => {
    disabled(s.email, () => this.emailDisabled());
    required(s.email, {
      message: this.getErrorMessage('required'),
    });
    pattern(s.email, regexes.EMAIL, {
      message: this.getErrorMessage('invalid'),
    });
  });

  readonly default = signal<EcomCashoutEmailFormModel>({
    email: '',
  });

  private getErrorMessage(error: string): string {
    return this.translate.instant(
      `ECOMCASHOUT.SETECOM.EMAIL.ERROR.${error.toUpperCase()}`,
    );
  }
}
